"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Text = exports.TextContainer = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  text-align : left;\n  display    : flex;\n  align-items: ", "\n  min-height : 40px;\n"])), function (_ref) {
  var top = _ref.top;
  return top ? 'flex-start' : 'center';
});

exports.Container = Container;

var TextContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.TextContainer = TextContainer;

var Text = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size  : 14px;\n  font-weight: ", ";\n  margin-left: ", "px;\n  color: ", ";\n"])), _widths.font.regular, _widths.widths.base * 2, function (props) {
  return props.color ? props.color : props['data-title'] ? _palette.palette.grey : _palette.palette.bobBlack;
});

exports.Text = Text;

var Title = _styledComponents["default"].h2(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size    : 20px;\n  font-weight  : ", ";\n  color        : ", ";\n  margin-left  : ", "px;\n  margin-top   : 0;\n  margin-bottom: 0;\n"])), _widths.font.semi, function (props) {
  return props.color || _palette.palette.bobBlack;
}, _widths.widths.base * 2);

exports.Title = Title;
Container.displayName = 'Container';
TextContainer.displayName = 'TextContainer';
Text.displayName = 'Text';
Title.displayName = 'Title';